// // PendingDealCard.jsx
// // Created: 06-04-2026
// // Shows a deal with stage "payment_pending" that has no payment yet.
// // Displays auto-fetched deal data and an "Incomplete Data" warning tag
// // if any required fields are missing. Clicking "Record Payment" opens
// // PaymentForm pre-filled with this deal's data.

// import React from "react";
// import { motion } from "framer-motion";
// import { TrendingUp, User, Home, Calendar, AlertTriangle, CreditCard } from "lucide-react";
// import { format } from "date-fns";
// import "../../css/payments/pendingdealcard.css";

// const fmtAmt = (n) =>
//   n >= 10_000_000 ? `₹${(n / 10_000_000).toFixed(2)}Cr`
//   : n >= 100_000   ? `₹${(n / 100_000).toFixed(1)}L`
//   : n >= 1_000     ? `₹${(n / 1_000).toFixed(0)}K`
//   : `₹${n}`;

// export default function PendingDealCard({ deal, index, onRecordPayment }) {
//   const {
//     dealName,
//     dealValue,
//     expectedCloseDate,
//     leadID,
//     propertyID,
//     isIncomplete,
//     missingFields = [],
//   } = deal;

//   return (
//     <motion.div
//       className="pending-deal-card-wrapper"
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ delay: index * 0.05 }}
//     >
//       <div className={`pending-deal-card ${isIncomplete ? "is-incomplete" : ""}`}>

//         {/* Header */}
//         <div className="pdc-header">
//           <div className="pdc-icon">
//             <TrendingUp size={18} />
//           </div>

//           <div className="pdc-title">
//             <h3>{dealName || "Unnamed Deal"}</h3>
//             <span className="pdc-stage-badge">Payment Pending</span>
//           </div>

//           {isIncomplete && (
//             <div className="pdc-incomplete-tag">
//               <AlertTriangle size={12} />
//               Incomplete
//             </div>
//           )}
//         </div>

//         {/* Deal Info */}
//         <div className="pdc-body">
//           <div className="pdc-row">
//             <CreditCard size={13} />
//             <span>
//               {dealValue
//                 ? fmtAmt(Number(dealValue))
//                 : <em className="pdc-missing">Deal value not set</em>}
//             </span>
//           </div>

//           <div className="pdc-row">
//             <Calendar size={13} />
//             <span>
//               {expectedCloseDate
//                 ? `Due: ${format(new Date(expectedCloseDate), "dd MMM yyyy")}`
//                 : <em className="pdc-missing">Close date not set</em>}
//             </span>
//           </div>

//           <div className="pdc-row">
//             <User size={13} />
//             <span>
//               {leadID
//                 ? (typeof leadID === "object" ? leadID.full_name : "Lead linked")
//                 : <em className="pdc-missing">No lead linked</em>}
//             </span>
//           </div>

//           <div className="pdc-row">
//             <Home size={13} />
//             <span>
//               {propertyID
//                 ? (typeof propertyID === "object" ? propertyID.propertyName : "Property linked")
//                 : <em className="pdc-missing">No property linked</em>}
//             </span>
//           </div>

//           {isIncomplete && missingFields.length > 0 && (
//             <div className="pdc-missing-list">
//               <AlertTriangle size={11} />
//               <span>Missing: {missingFields.join(", ")}</span>
//             </div>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="pdc-footer">
//           <button
//             className="pdc-record-btn"
//             onClick={() => onRecordPayment(deal)}
//           >
//             <CreditCard size={13} />
//             Record Payment
//           </button>
//         </div>

//       </div>
//     </motion.div>
//   );
// }

// PendingDealCard.jsx
// Created: 06-04-2026
// Shows a deal with stage "payment_pending" that has no payment yet.
// Displays auto-fetched deal data and an "Incomplete Data" warning tag
// if any required fields are missing. Clicking "Record Payment" opens
// PaymentForm pre-filled with this deal's data.

import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, User, Home, Calendar, AlertTriangle, CreditCard } from "lucide-react";
import { format } from "date-fns";
import "../../css/payments/pendingdealcard.css";

const fmtAmt = (n) =>
  n >= 10_000_000 ? `₹${(n / 10_000_000).toFixed(2)}Cr`
  : n >= 100_000   ? `₹${(n / 100_000).toFixed(1)}L`
  : n >= 1_000     ? `₹${(n / 1_000).toFixed(0)}K`
  : `₹${n}`;

export default function PendingDealCard({ deal, index, onRecordPayment }) {
  const {
    dealName,
    dealValue,
    expectedCloseDate,
    leadID,
    propertyID,
    isIncomplete,
    missingFields = [],
  } = deal;

  return (
    <motion.div
      className="pending-deal-card-wrapper"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
    >
      <div className={`pending-deal-card ${isIncomplete ? "is-incomplete" : ""}`}>

        {/* Header */}
        <div className="pdc-header">
          <div className="pdc-icon">
            <TrendingUp size={18} />
          </div>

          <div className="pdc-title">
            <h3>{dealName || "Unnamed Deal"}</h3>
            <span className="pdc-stage-badge">Payment Pending</span>
          </div>

          {isIncomplete && (
            <div className="pdc-incomplete-tag">
              <AlertTriangle size={12} />
              Incomplete
            </div>
          )}
        </div>

        {/* Deal Info */}
        <div className="pdc-body">
          <div className="pdc-row">
            <CreditCard size={13} />
            <span>
              {dealValue
                ? fmtAmt(Number(dealValue))
                : <em className="pdc-missing">Deal value not set</em>}
            </span>
          </div>

          <div className="pdc-row">
            <Calendar size={13} />
            <span>
              {expectedCloseDate
                ? `Due: ${format(new Date(expectedCloseDate), "dd MMM yyyy")}`
                : <em className="pdc-missing">Close date not set</em>}
            </span>
          </div>

          <div className="pdc-row">
            <User size={13} />
            <span>
              {leadID
                ? (typeof leadID === "object" ? leadID.full_name : "Lead linked")
                : <em className="pdc-missing">No lead linked</em>}
            </span>
          </div>

          <div className="pdc-row">
            <Home size={13} />
            <span>
              {propertyID
                ? (typeof propertyID === "object" ? propertyID.propertyName : "Property linked")
                : <em className="pdc-missing">No property linked</em>}
            </span>
          </div>

          {isIncomplete && missingFields.length > 0 && (
            <div className="pdc-missing-list">
              <AlertTriangle size={11} />
              <span>Missing: {missingFields.join(", ")}</span>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="pdc-footer">
          <button
            className="pdc-record-btn"
            onClick={() => onRecordPayment(deal)}
          >
            <CreditCard size={13} />
            Record Payment
          </button>
        </div>

      </div>
    </motion.div>
  );
}